/** The manifest's station slugs alone, for code that ships to the browser without the
 *  listing's facts. */
export const LISTED_STATION_SLUGS: readonly string[] = [
    '/stations/south-station-boston--bossst',
    '/stations/atlanta-greyhound-bus-station--atlgli',
    '/stations/penn-station-baltimore--balamt',
    '/stations/chicago-greyhound-bus-station--chigli3',
    '/stations/union-station-chicago--chiust',
    '/stations/union-station-washington-dc--dcaust',
    '/stations/union-station-los-angeles--laxust',
    '/stations/new-haven-union-station--nhvusflx',
    '/stations/penn-station-newark--nwkpns',
    '/stations/new-york-31st-st-8th-ave-bus-stop--nycgob2',
    '/stations/port-authority-bus-terminal--nycpas',
    '/stations/penn-station-new-york--nycpen',
    '/stations/gw-bridge-bus-terminal--nycusour7',
    '/stations/orlando-greyhound-bus-station--orlgli',
    '/stations/30th-street-station-philadelphia--phltth',
    '/stations/phoenix-bus-station--phxamt',
    '/stations/santa-de-depot-san-diego--sanamt2',
    '/stations/king-street-station--seaamt',
    '/stations/houston-greyhound-bus-station--hougli',
    '/stations/huntington-park-tufesa-station--hgouscor',
    '/stations/mcallen-central-station--mengps',
]
